import React from 'react';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Popover } from '@televet/kibble-ui/build/components/Popover';

interface ConfirmDeletePopoverProps {
  title: string;
  description: string;
  onConfirm: () => void;
}

const ConfirmDeletePopover = ({ title, description, onConfirm }: ConfirmDeletePopoverProps): JSX.Element => {
  return (
    <Popover
      headerProps={{ children: title }}
      footerProps={{ submitText: 'Yes, Delete', onSubmit: onConfirm }}
      placement="top"
      variant="contrastDestructive"
      anchor={<Button iconName="trashcan" variant="ghostNeutral" />}
      size="md"
    >
      {description}
    </Popover>
  );
};

export default ConfirmDeletePopover;
